export const customTheme= {
    components: {
        Table: {
            cellPaddingBlockSM: 4,
            cellFontSizeSM: 12
        }
    }
};